import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HasystemsettingsService } from '../../services/HaSystemSettings.service';
import { HttpEventType, HttpErrorResponse } from '@angular/common/http';
import { AlertType, AlertMessages } from '../../../../core/AlertMessages';
import { ErrorModel } from '../../../../shared/models/Error.model';

@Component({
  selector: 'app-ha-system-setting',
  templateUrl: './ha-system-setting.component.html',
  styleUrls: ['./ha-system-setting.component.css']
})

export class HaSystemSettingComponent implements OnInit {
  videoSrc;
  pictureSrc;
  videoString;
  currentLogo;
  //when selection is done
  selectedLogo: File;
  selectedHeaderImage: File;
  selectedFooterImage: File;
  selectedVideo: File;
  //for showing percentages
  loadingLogoPercentage;
  loadingHeaderPercentage;
  loadingFooterPercentage;
  loadingVideoPercentage;
  //switches for showing Loading
  showLogoPer: boolean = false;
  showVideoPer: boolean = false;
  showHeaderPer: boolean = false;
  showFooterPer: boolean = false;
  currentHeader;
  currentFooter;
  currentHeaderText;
  currentFooterText;
  showOverlay: boolean;
  mainViewError = new ErrorModel();

  constructor(private _sanitizer: DomSanitizer, private _service: HasystemsettingsService) { }

  ngOnInit() {
     this.videoString = 'https://www.youtube.com/embed/UCPUFgOSoC8';
     this.videoSrc = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/UCPUFgOSoC8');
    this.getSystemSettingData();

  }

  getSystemSettingData() {
    this.showOverlay = true;
    this.mainViewError.display = false;
    this._service.getSystemSettingsData().subscribe(
    (data) => {
      if(data["photo"] == null || data["photo"] == undefined){
        this.pictureSrc = null;
      } else {
        this.pictureSrc = this._sanitizer.bypassSecurityTrustResourceUrl(data["photo"]);
      }

      //  this.videoSrc = this._sanitizer.bypassSecurityTrustResourceUrl(data["video"]);
      //  this.videoSrc = this._sanitizer.bypassSecurityTrustResourceUrl(data["video"]);

      if(data["headerImage"] == null || data["headerImage"] == undefined) {
        this.currentHeader = null;
      } else {
        this.currentHeader = this._sanitizer.bypassSecurityTrustResourceUrl(data["headerImage"]);
      }
      if(data["footerImage"] == null || data["footerImage"] == undefined) {
        this.currentFooter = null;
      } else {
        this.currentFooter = this._sanitizer.bypassSecurityTrustResourceUrl(data["footerImage"]);
      }
      this.currentHeaderText = data["headerText"];
      this.currentFooterText = data["footerText"];
      this.showOverlay = false;
    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;

    }).add(() => {
      this.showOverlay = false;
    });
  }

  getVideo(evt) {
    let File = evt.target.files;
    let Video = File[0];
    if (Video.name.search(/.mp4|.3gp|.ogg|.wmv|.m4a|.flv /g) == -1) {
      AlertMessages.Show("WARNING",'Please add a video file ( mp4,3gp,ogg,m4a,flv )',AlertType.Warning);
    } else {
      this.selectedVideo = Video;
    }
  }


  getLogo(evt) {
    const File = evt.target.files;
    const Photo = File[0];
    if (Photo.name.search(/.jpg|.jpeg|.png|.tiff|.bmp /g) == -1) {
      AlertMessages.Show("WARNING",'Please add an Image file ( jpg,jpeg,png,tiff,bmp )',AlertType.Warning);
    } else {
      this.selectedLogo = Photo;
      let reader = new FileReader();
      reader.onload = (evt: any) => {
        this.pictureSrc = evt.target.result;
      }
      reader.readAsDataURL(evt.target.files[0]);
    }
  }

  getImage(evt, type) {
    let File = evt.target.files;
    let Photo = File[0];
    if (Photo.name.search(/.jpg|.jpeg|.png|.tiff|.bmp /g) == -1) {
      AlertMessages.Show("WARNING",'Please add an Image file ( jpg,jpeg,png,tiff,bmp )',AlertType.Warning);
    } else {
      let reader = new FileReader();
      switch(type) {
        case 0:
          this.selectedHeaderImage = Photo;
          reader.onload = (evt: any) => {
            this.currentHeader = evt.target.result;
          }
          break;
        case 1:
          this.selectedFooterImage = Photo;
          reader.onload = (evt: any) => {
            this.currentFooter = evt.target.result;
          }
          break;
        case 2:
          this.selectedLogo = Photo;
          reader.onload = (evt: any) => {
            this.pictureSrc = evt.target.result;
          }
          break;
        default:
          alert('ERROR:'+type+ " is not accounted for..");
      }
      reader.readAsDataURL(evt.target.files[0]);
    }
  }

//-----------------------------------------------------
uploadImage(type) {
  let imageName = type == 0 ? this.selectedHeaderImage : this.selectedFooterImage;
  if( imageName == undefined || imageName == null) {
    AlertMessages.Show("WARNING",'Please choose File to upload',AlertType.Warning);
  } else if (imageName.name.search(/.jpg|.jpeg|.png|.tiff|.bmp /g) == -1) {
    AlertMessages.Show("WARNING", 'Please add an Image file ( jpg,jpeg,png,tiff,bmp )',AlertType.Warning);
  } else {
    type == 0 ? this.showHeaderPer = true : this.showFooterPer = true;
    this._service.uploadImage(imageName,type).subscribe(
    (event) => {
      if (event.type == HttpEventType.UploadProgress) {
        let uploadStat = Math.round(event.loaded / event.total * 100);
        type == 0 ? this.loadingHeaderPercentage = uploadStat : this.loadingFooterPercentage = uploadStat;
      } else if (event.type == HttpEventType.Response) {
        if(event.body["Id"]==1){
          AlertMessages.Show("Success", JSON.stringify(event.body["StatusMessage"]),AlertType.Success);
        } else {
          AlertMessages.Show("Error", JSON.stringify(event.body["StatusMessage"]),AlertType.Error);
        }
        type == 0 ? this.showHeaderPer = false : this.showFooterPer = false;
        let reader = new FileReader();
        reader.onload = (abc: any) => {
          type == 0 ? this.currentHeader = abc.target.result : this.currentFooter = abc.target.result;
        }
      }
    },
    (error) => {
      AlertMessages.Show("Failed", 'Could not upload!', AlertType.Error);

    }).add(() => {
      this.showHeaderPer = false;
      this.showFooterPer = false;
    });
  }
}



  uploadLogo() {
    alert('This functionality is not implemented.');
  }

  uploadVideo() {
    this.showVideoPer = true;
    if (this.selectedVideo == undefined || this.selectedVideo == null) {
      this.showVideoPer = false;
        AlertMessages.Show("WARNING",'Please choose File to upload',AlertType.Warning);
    } else {
      this._service.uploadVideo(this.selectedVideo).subscribe((event) => {
        if (event.type == HttpEventType.UploadProgress) {
          this.loadingVideoPercentage = Math.round(event.loaded / event.total * 100);
        }
        else if (event.type == HttpEventType.Response) {
          if(event.body["Id"]==1){
            AlertMessages.Show("Success", JSON.stringify(event.body["StatusMessage"]),AlertType.Success);
          }
          else{
            AlertMessages.Show("Error", JSON.stringify(event.body["StatusMessage"]),AlertType.Error);
          }
          this.showVideoPer = false;
          var reader = new FileReader();
          reader.onload = (data: any) => {
            this.videoSrc = this._sanitizer.bypassSecurityTrustResourceUrl(data.target.result);
          }
        }
      }, (error: HttpErrorResponse) => { this.showVideoPer = false; alert(error.statusText); });
    }
  }


  saveText(value, type) {
    let imageType = type == 0 ? 'Header' : 'Footer';
    if (value != null && value != undefined && value != "") {
        this._service.uploadText(value, type).subscribe((data) => {
       AlertMessages.Show("Uploaded", imageType+' uploaded successfully', AlertType.Success);
    })
     } else {
         AlertMessages.Show("WARNING",'Please provide '+imageType+' text..', AlertType.Warning);
    }
}

}


